import { useMutation } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

import { IMapUnmapPaycorEmployee } from './useMapUnmapPaycorEmployees';

export interface IBulkMapUnmapPaycorEmployees {
  mapping: boolean;
  data: Array<Omit<IMapUnmapPaycorEmployee, 'mapping'>>;
}

const bulkMapUnmapPaycorEmployees = (postData: IBulkMapUnmapPaycorEmployees) => {
  return http().post(endpoints.integrations.paycor.bulkMapUnmap, postData);
};

export function useBulkMapUnmapPaycorEmployees() {
  return useMutation({ mutationFn: bulkMapUnmapPaycorEmployees });
}
